import Typography from "@material-ui/core/esm/Typography";
import clsx from 'clsx';
import React from 'react';
import useStyles from './TextStyles';
export default function Header({
  children,
  align,
  hasNoSpacing,
  component = 'h2'
}) {
  const {
    title,
    noSpacing
  } = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    align: align,
    variant: "h2",
    className: clsx(title, hasNoSpacing && noSpacing),
    component: component
  }, children);
}
Header.defaultProps = {
  align: 'left',
  to: '',
  hasNoSpacing: false,
  component: 'h2'
};